import { render } from "./prescriptionHospitalScanPaymentCCDSYY.vue?vue&type=template&id=37a6a492&scoped=true"
import script from "./prescriptionHospitalScanPaymentCCDSYY.vue?vue&type=script&lang=js"
export * from "./prescriptionHospitalScanPaymentCCDSYY.vue?vue&type=script&lang=js"

import "./prescriptionHospitalScanPaymentCCDSYY.vue?vue&type=style&index=0&id=37a6a492&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a6a492"]])

export default __exports__